import "./style.css";
import Wilson from "../../images/About/sanches.png";

export default function About() {
  return (
    <div className="about">
      <div className="about-container">
        <div className="about-text">
          <h2>Quem é Wilson Sanches?</h2>
          <p>
            Prazer, sou o Wilson, um apaixonado pelo universo da beleza com mais de 40 anos de experiência prática na área.
            <br/><br/>
            Durante minha trajetória, vivi de tudo: erros, acertos, desafios e grandes conquistas. E foi justamente nesse caminho que desenvolvi minha missão: ajudar profissionais da beleza a se tornarem reconhecidos, valorizados e financeiramente realizados.
            <br/><br/>
            Ao longo dos anos, acompanhei de perto a transformação de diversos profissionais que saíram do zero e passaram a viver com propósito, técnica e visão de futuro. Eu sei o que funciona, e é isso que ensino.
            <br/><br/>
            Na mentoria Beleza Lucrativa, você não aprende só sobre beleza. Aprende também a vender, se posicionar e crescer de forma sólida. E ainda conta com bônus exclusivos sobre tráfego pago e presença digital, porque hoje, um profissional completo precisa dominar muito mais do que só a tesoura.
            <br/><br/>
            Se você sente que está pronta(o) para dar o próximo passo e conquistar o espaço que merece, eu estou aqui para te guiar.
          </p>
        </div>
        <div className="about-image">
          <img src={Wilson} alt="Wilson Sanches"/>
        </div>
      </div>
    </div>
  );
};